import { usePage } from "@inertiajs/react";
import { Fragment } from "react";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb.tsx";
import type { BizminerInertiaSharedProps } from "@/types/inertia.ts";

export const Breadcrumbs = () => {
  const { props } = usePage<BizminerInertiaSharedProps>();
  const breadcrumbs = (props.breadcrumbs as BreadcrumbItem[]) || [];
  if (!breadcrumbs) {
    return;
  }
  return (
    <Breadcrumb>
      <BreadcrumbList>
        {breadcrumbs.map((crumb, index) => (
          <Fragment key={crumb.href ?? crumb.label}>
            {index > 0 && (
              <BreadcrumbSeparator
                className={index === 1 ? "hidden md:block" : ""}
              />
            )}
            <BreadcrumbItem className={index === 0 ? "hidden md:block" : ""}>
              {index === breadcrumbs.length - 1 || !crumb.href ? (
                <BreadcrumbPage>{crumb.label}</BreadcrumbPage>
              ) : (
                <BreadcrumbLink href={crumb.href}>{crumb.label}</BreadcrumbLink>
              )}
            </BreadcrumbItem>
          </Fragment>
        ))}
      </BreadcrumbList>
    </Breadcrumb>
  );
};
